<template>
  <theme-switcher
    :themes="themes"
    :active="activeTheme"
    @toggle="toggleTheme"
  />
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { TOGGLE_THEME } from '@/store/mutation-types'

import ThemeSwitcher from '@/containers/Navigation/ThemeSwitcher'

export default {
  components: {
    ThemeSwitcher
  },
  computed: {
    ...mapState({
      activeTheme: state => state.theme.active,
      themes: state => state.theme.types
    })
  },
  methods: {
    ...mapMutations({ toggleTheme: TOGGLE_THEME })
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Navigation/ThemeSwitcherContainer.vue